<template>
  <div id="tree-table" class="title-panel">
    <TreeTable :value="value" striped>
      <Column
        v-for="col of columns"
        :key="col.field"
        :field="col.field"
        :header="col.header"
        :expander="col.expander"
        :style="col.width ? { width: col.width } : {}"
      >
        <template #body="slotProps">
          <div v-if="slotProps.column.props.field === 'fulfillment'">
            <Tag
              :value="`${slotProps.node.data.fulfillment.current} / ${slotProps.node.data.fulfillment.target}`"
              :style="
                getFulfillmentColor(
                  slotProps.node.data.fulfillment.current,
                  slotProps.node.data.fulfillment.target,
                )
              "
              severity="info"
            />
          </div>
          <div v-else>
            <span>{{
              slotProps.node.data[
                slotProps.column.props.field as keyof typeof slotProps.node.data
              ]
            }}</span>
          </div>
        </template>
      </Column>
      <template #empty>
        <span class="flex justify-center italic">{{ emptyMessage }}</span>
      </template>
    </TreeTable>
  </div>
</template>

<script setup lang="ts">
  import { TreeTable, Column } from 'primevue';
  import { TreeNode } from 'primevue/treenode';
  import Tag from 'primevue/tag';
  import { computed } from 'vue';

  /** PROPS */
  const props = defineProps<{
    data: TreeNode[];
    columns: {
      field: string;
      header: string;
      expander?: boolean;
      width?: string;
    }[];
    emptyMessage?: string;
  }>();

  const value = computed(() => {
    return props.data;
  });

  const columns = computed(() => {
    return props.columns;
  });

  const getFulfillmentColor = (current: number, target: number): string => {
    if (current > target) {
      return 'background-color: color-mix(in srgb, var(--p-blue-500), transparent 84%); color: var(--p-blue-500)';
    }
    if (current === target) {
      return 'background-color: color-mix(in srgb, var(--p-green-500), transparent 84%); color: var(--p-green-500)';
    }
    return 'background-color: color-mix(in srgb, var(--p-red-500), transparent 84%); color: var(--p-red-500)';
  };
</script>

<style scoped lang="scss"></style>
